export function extractNameIdentifier(jwt) {
  // Split the JWT into three parts: header, payload, and signature
  const parts = jwt.split(".");

  if (parts.length !== 3) {
    throw new Error("Invalid JWT");
  }

  // Decode the payload (second part) from Base64
  const payload = atob(parts[1]);

  // Parse the payload as JSON
  const parsedPayload = JSON.parse(payload);

  // Extract the 'nameidentifier' from the payload
  return parsedPayload[
    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
  ];
}
